import React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Collapse, ListItem } from '@mui/material';
import { ChevronDown as ChevronDownIcon } from '../../shared/Icons/chevron-down';
import { ChevronRight as ChevronRightIcon } from '../../shared/Icons/chevron-right';
import { useNavigate } from 'react-router-dom';

export const SidebarItem = (props) => {
  const navigate = useNavigate();

  const {
    active,
    children,
    // eslint-disable-next-line react/prop-types
    chip,
    depth,
    icon,
    info,
    open: openProp,
    // eslint-disable-next-line no-unused-vars
    path,
    title,
    ...other
  } = props;
  const [open, setOpen] = useState(!!openProp);
  let paddingLeft = 24;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  // Branch
  if (children) {
    return (
      <ListItem
        disableGutters
        sx={{
          display: 'block',
          mb: 0.5,
          py: 0,
          px: 2
        }}
        {...other}>
        <Button
          endIcon={
            !open ? <ChevronRightIcon fontSize="small" /> : <ChevronDownIcon fontSize="small" />
          }
          disableRipple
          onClick={handleToggle}
          startIcon={icon}
          sx={{
            color: active ? 'secondary.main' : 'neutral.300',
            justifyContent: 'flex-start',
            pl: `${paddingLeft}px`,
            pr: 3,
            textAlign: 'left',
            textTransform: 'none',
            width: '100%',
            '&:hover': {
              backgroundColor: 'rgba(255,255,255, 0.08)'
            },
            '& .MuiButton-startIcon': {
              color: active ? 'secondary.main' : 'neutral.400'
            },
            '& .MuiButton-endIcon': {
              color: 'neutral.400'
            }
          }}>
          <Box sx={{ flexGrow: 1 }}>{title}</Box>
          {info}
        </Button>
        <Collapse in={open} sx={{ mt: 0.5 }}>
          {children}
        </Collapse>
      </ListItem>
    );
  }

  // Leaf
  return (
    <ListItem
      disableGutters
      sx={{
        display: 'flex',
        mb: 0.5,
        py: 0,
        px: 2
      }}>
      <Button
        component="a"
        startIcon={icon}
        endIcon={chip}
        onClick={() => navigate(path)}
        disableRipple
        sx={{
          borderRadius: 1,
          color: 'neutral.300',
          justifyContent: 'flex-start',
          pl: `${paddingLeft}px`,
          pr: 3,
          textAlign: 'left',
          textTransform: 'none',
          width: '100%',
          ...(active && {
            backgroundColor: 'rgba(255,255,255, 0.08)',
            color: 'secondary.main',
            fontWeight: 'fontWeightBold'
          }),
          '& .MuiButton-startIcon': {
            color: active ? 'secondary.main' : 'neutral.400'
          },
          '&:hover': {
            backgroundColor: 'rgba(255,255,255, 0.08)'
          }
        }}>
        <Box sx={{ flexGrow: 1 }}>{title}</Box>
        {info}
      </Button>
    </ListItem>
  );
};

SidebarItem.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  depth: PropTypes.number.isRequired,
  icon: PropTypes.node,
  info: PropTypes.node,
  open: PropTypes.bool,
  path: PropTypes.string,
  title: PropTypes.string.isRequired
};

SidebarItem.defaultProps = {
  active: false,
  open: false
};
